import React from "react";
import Table from "../../../../core/Table";
import BasicDialog from "../../../../core/BasicDialog/BasicDialog";
import { labels } from "../../../../../localization/labels";

const EntityRelationships = ({
  node,
  data,
  columns,
  paginationOptions,
  onTableChange,
  onRowClick,
  contextMenuItems,
  handleShow,
  pageInfo,
  selectRow,
  handleOnDelete,
  show,
  handleClose,
  entity,
  onSave,
  onChange,
  disabled,
  validationRules,
  handleEntered,
  maxLength,
  inputFields,
  saveButtonText
}) => {
  return (
    <>
      <Table
        node={node}
        data={data}
        columns={columns}
        onTableChange={onTableChange}
        onRowClick={onRowClick}
        paginationOptions={paginationOptions}
        selectRow={selectRow}
        contextMenuItems={contextMenuItems}
        pageInfo={pageInfo}
        onDeleteRow={handleOnDelete}
        onCreateRow={handleShow}
        tableLabel={labels.entityRelationshipRelated}
        showTableHeader
      />
      <BasicDialog
        dialogTitle={labels.entityRelationShip}
        show={show}
        handleClose={handleClose}
        entity={entity}
        maxLength={maxLength}
        onSave={onSave}
        onChange={onChange}
        disabled={disabled}
        validationRules={validationRules}
        handleEntered={handleEntered}
        additionalInputFields={inputFields}
        saveButtonText={saveButtonText}
      />
    </>
  );
};

export default EntityRelationships;
